import clsx from 'clsx';
import { CSSProperties, useMemo } from 'react';

import style from './spinner.module.scss';

export enum SpinnerSize {
  mini = -1,
  small = 0,
  medium,
  large,
}

export enum SpinnerPositioning {
  default = 0,
  transform,
  transformRelative,
  flex,
}

export interface SpinnerConfiguration {
  size: SpinnerSize;
  positioning?: SpinnerPositioning;
  color?: string;
  secondaryColor?: string;
  hidePadding?: boolean;
}

export const Spinner = ({ size, positioning, color, secondaryColor, hidePadding }: SpinnerConfiguration) => {
  const cssStyle = useMemo(() => {
    const css: { [key: string]: string } = {};
    if (color) {
      css['--color'] = color;
    }
    if (secondaryColor) {
      css['--color-secondary'] = secondaryColor;
    }
    return css as CSSProperties;
  }, [color, secondaryColor]);

  const spinnerMarkup = (
    <div
      className={clsx(style.container, {
        [style.positioningTransform]: positioning === SpinnerPositioning.transform || positioning === SpinnerPositioning.transformRelative,
        [style.absolute]: positioning === SpinnerPositioning.transform,
      })}
      style={cssStyle}
    >
      <svg
        className={clsx(
          style.loader,
          { [style.mini]: size === SpinnerSize.mini },
          { [style.small]: size === SpinnerSize.small },
          { [style.medium]: size === SpinnerSize.medium },
          { [style.large]: size === SpinnerSize.large },
          { [style.hidePadding]: hidePadding }
        )}
        viewBox="0 0 24 24"
      >
        <circle className={clsx(style.loader__value)} cx="12" cy="12" r="10" />
        <circle className={clsx(style.loader__value)} cx="12" cy="12" r="10" />
      </svg>
    </div>
  );

  if (positioning === SpinnerPositioning.flex) {
    return <div className={clsx(style.outerContainer, { [style.flex]: positioning === SpinnerPositioning.flex })}>{spinnerMarkup}</div>;
  }
  return spinnerMarkup;
};

export default Spinner;
